import axios from 'axios'
import { tns } from 'tiny-slider/src/tiny-slider'
import SimpleLightbox from "simplelightbox";

var burger2 = document.querySelector(".burger2");
var menuNav = document.querySelector(".menu__nav")

burger2.addEventListener("click", () => {
    if (menuNav.style.display == "block") {
        menuNav.style.display = "none"
        burger2.classList.remove("on");
    } else {
        menuNav.style.display = "block"
        burger2.classList.add("on");
    }
});

function fadeOut (element) {
    var op = 1;  // initial opacity
    var timer = setInterval(function () {
        if (op <= 0.1) {
            clearInterval(timer);
            element.style.display = 'none';
        }
        element.style.opacity = op;
        element.style.filter = 'alpha(opacity=' + op * 100 + ")";
        op -= op * 0.1;
    }, 10);
}

function fadeIn (element) {
    var op = 0.1;  // initial opacity
    element.style.display = 'block';
    var timer = setInterval(function () {
        if (op >= 1) {
            clearInterval(timer);
        }
        element.style.opacity = op;
        element.style.filter = 'alpha(opacity=' + op * 100 + ")";
        op += op * 0.1;
    }, 10);
}

// gallery load more
if (document.querySelector('.gallery__load .button')) {
    document.querySelector('.gallery__load .button').addEventListener('click', (event) => {
        event.preventDefault();

        axios.get(event.target.href).then(response => {
            document.querySelector('.gallery__grid').innerHTML += response.data.images
            new SimpleLightbox('.gallery__grid a[data-image]', {});
            if (response.data.next) {
                event.target.href = response.data.next
            } else {
                document.querySelector('.gallery__load').style.display = 'none';
            }
        })
    });
}

// page filters
if (document.querySelectorAll('.filter input, .filter select')) {
    document.querySelectorAll('.filter input:not(.js-search), .filter select').forEach(element => {
        element.addEventListener('change', () => {
            document.querySelector('.filter').submit()
        })
    })
}

// homepage slider
if (document.querySelector('.homeslider')) {
    let homeslider = tns({
        container: '.homeslider',
        items: 1,
        mouseDrag: false,
        loop: true,
        nav: false,
        controls: false,
        autoplay: true,
        autoplayTimeout: 10000,
        autoplayHoverPause: false,
    })

    var homesliderDots = document.querySelectorAll('.slider__dot')

    homeslider.events.on('indexChanged', function (event) {

        let slideInfo = homeslider.getInfo(),
            slideIndex = slideInfo.displayIndex

        homesliderDots.forEach(function (element, index) {
            if (slideIndex - 1 == index) {
                element.classList.add('slider__dot--active')
            } else {
                element.classList.remove('slider__dot--active')
            }
        })
    })
    homesliderDots.forEach(function (element, index) {
        element.addEventListener('click', function (event) {
            homeslider.goTo(index)
        })
    })

    document.querySelector('.slider__nav-prev').addEventListener('click', (event) => {
        event.preventDefault();
        homeslider.goTo('prev');
    })
    document.querySelector('.slider__nav-next').addEventListener('click', (event) => {
        event.preventDefault();
        homeslider.goTo('next');
    })

}

// locationslider slider
if (document.querySelector('.locationslider')) {
    let locationslider = tns({
        container: '.locationslider',
        items: 1,
        mouseDrag: true,
        loop: false,
        nav: false,
        controls: false,
        edgePadding: 20,
        responsive: {
            600: {
                items: 2,
                edgePadding: 20,
            },
            992: {
                items: 3,
                edgePadding: 0
            },
            1260: {
                items: 4
            }
        }
    })
}

document.querySelectorAll('.form__input').forEach((input) => {
    input.addEventListener('focusout', (event) => {
        if (input.value.trim().length > 0) {
            input.nextSibling.nextSibling.classList.add('form__label--active')
        } else {
            input.nextSibling.nextSibling.classList.remove('form__label--active')
        }
    })
})

if (document.querySelectorAll('.p-content__html').length) {
    document.querySelectorAll('.p-content__html p > span').forEach(span => {
        span.parentNode.nextSibling.classList.add('afterTitle')
    })
}


if (window.innerWidth <= 1200) {
    document.querySelectorAll('.menu__item--dropdown').forEach(element => {
        element.removeAttribute('onclick')
        element.addEventListener('click', (e) => {
            if (e.target.classList.contains('menu__item--dropdown')) {
                e.preventDefault()
                if (element.classList.contains('menu__item--open')) {
                    element.classList.remove('menu__item--open')
                    element.querySelector('.submenu').classList.remove('submenu--open')
                } else {
                    element.classList.add('menu__item--open')
                    element.querySelector('.submenu').classList.add('submenu--open')
                }
            }
        })
    })

    document.querySelectorAll('div.submenu__link').forEach(element => {
        element.removeAttribute('onclick')
        element.addEventListener('click', (e) => {
            if (e.target.tagName == 'DIV') {
                e.preventDefault()
                e.stopPropagation()
                e.stopImmediatePropagation()

                if (element.classList.contains('submenu__link--open')) {
                    element.classList.remove('submenu__link--open')
                    element.querySelector('.submenu').classList.remove('submenu--open')
                } else {
                    element.classList.add('submenu__link--open')
                    element.querySelector('.submenu').classList.add('submenu--open')
                }
            }
        })
    })
}

// open search
document.querySelector('.menu__search').addEventListener('click', (event) => {
    event.preventDefault();

    const search = document.querySelector('.menu__search')

    if (search.classList.contains('menu__search--open')) {
        search.classList.remove('menu__search--open');
        document.querySelector('.search').classList.remove('search--open')
        document.querySelector('body').classList.remove('overflow')
    } else {
        search.classList.add('menu__search--open');
        document.querySelector('.search').classList.add('search--open')
        document.querySelector('body').classList.add('overflow')
    }
})

function debounce (func, timeout = 300) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

document.querySelector('.search__form').addEventListener('submit', (e) => {
    e.preventDefault();
})

let searchFunction = debounce((e, page) => {
    let searchString = document.querySelector('.search__input').value.trim()
    if (!page) {
        page = 1
    }

    if (searchString.length >= 3) {
        // show loader
        document.querySelector('.search__loader').style.display = 'block'

        // hide search content
        document.querySelector('.s-results').style.display = 'none'

        axios.get('/search?s=' + searchString + '&page=' + page).then(response => {
            document.querySelector('.s-results').style.display = 'block'
            document.querySelector('.s-results__title').innerHTML = 'Výsledky vyhľadávania pre výraz “' + response.data.string + '”'
            document.querySelector('.s-results__count').innerHTML = response.data.count
            document.querySelector('.s-results__boxes').innerHTML = response.data.html
            document.querySelector('.search__loader').style.display = 'none'

            initSearchPagination()
        })
    } else {
        document.querySelector('.search__loader').style.display = 'none'
        document.querySelector('.s-results').style.display = 'none'
    }
})

document.querySelector('.search__input').addEventListener('input', searchFunction)

let initSearchPagination = () => {
    document.querySelectorAll('.s-results .pagination__pages [data-page]').forEach(element => {
        element.addEventListener('click', (e) => {
            e.preventDefault();

            searchFunction(e, element.getAttribute('data-page'))
        })
    })
}

if (document.querySelector('.js-search')) {
    document.querySelector('.js-search').addEventListener('keyup', function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        if (event.keyCode === 13) {
            window.find(event.target.value.trim())
        }
    });
}

new SimpleLightbox('.gallery__grid a[data-image]', {

});
